import React, { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Calculator from './components/Calculator';
import Portfolio from './components/Portfolio';
import Equipment from './components/Equipment';
import ContactModal from './components/ContactModal';
import Footer from './components/Footer';
import { MessageSquare, Phone } from 'lucide-react';

function App() {
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const [initialService, setInitialService] = useState('');

  const handleOpenContact = (serviceName = '') => {
    setInitialService(serviceName);
    setContactModalOpen(true);
  };

  return (
    <div className="app-root" style={{ background: 'var(--bg-dark)', minHeight: '100vh', color: 'var(--text-main)' }}>
      {/* Navigation */}
      <Navbar onOpenContact={handleOpenContact} />

      {/* Main Sections */}
      <main>
        <Hero onOpenContact={handleOpenContact} />
        <About onOpenContact={handleOpenContact} />
        <Services onOpenContact={handleOpenContact} />
        <Calculator onOpenContact={handleOpenContact} />
        <Portfolio />
        <Equipment />
      </main>

      {/* Footer */}
      <Footer onOpenContact={handleOpenContact} />

      {/* Sticky Quick Contact Floating Buttons */}
      <div
        style={{
          position: 'fixed',
          bottom: '2rem',
          right: '2rem',
          zIndex: 850,
          display: 'flex',
          flexDirection: 'column',
          gap: '0.75rem',
        }}
      >
        {/* WhatsApp Quick Connect */}
        <a
          href="https://wa.me/919677579748?text=Hello%20B%20Land%20Survey,%20I%20would%20like%20to%20enquire%20about%20a%20survey."
          target="_blank"
          rel="noopener noreferrer"
          style={{
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            background: '#25D366',
            color: '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 8px 25px rgba(37, 211, 102, 0.5)',
            textDecoration: 'none',
            transition: 'transform 0.2s ease',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
          onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
          title="Chat on WhatsApp"
        >
          <MessageSquare size={24} />
        </a>

        {/* Direct Call Button */}
        <a
          href="tel:+919677579748"
          style={{
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #e63946 0%, #0066ff 100%)',
            color: '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 8px 25px rgba(230, 57, 70, 0.5)',
            textDecoration: 'none',
            transition: 'transform 0.2s ease',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
          onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
          title="Call Land Surveyor"
        >
          <Phone size={22} />
        </a>
      </div>

      {/* Quote / Contact Modal */}
      <ContactModal
        isOpen={contactModalOpen}
        onClose={() => setContactModalOpen(false)}
        initialService={initialService}
      />
    </div>
  );
}

export default App;
